import Vue from 'vue'
export function getRoleList(data) {
    return Vue.axios({
        url: '/api/role/list',
        method: 'get',
        params: {...data}
    })
}
export function getRoleDialogList() {
    return Vue.axios({
        url: '/api/permission/list',
        method: 'get',
        params: {}
    })
}
//更新权限
export function initPermissions() {
    return Vue.axios({
        url: '/api/permission/initPermissions',
        method: 'get',
        params: {}
    })
}
export function roleStore(data) {
    return Vue.axios({
        url: '/api/role/store',
        method: 'post',
        data: { ...data }
    })
}
export function roleEditDetail(id) {
    return Vue.axios({
        url: '/api/role/detail',
        method: 'get',
        params: { id }
    })
}
export function roleDelete(id) {
    return Vue.axios({
        url: '/api/role/delete',
        method: 'get',
        params: { id}
    })
}